import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    setApplicationType,
    setApplicants,
    setMortgageType,
    setApplicantsIncome,
    setEstaminatedPropertyValue,
    setEstaminatedPropertyMonthlyRent,
    setRequestedLoanAmount,
    setRequestedTimeSpan,
    getQuickQuote,
} from './quickQuoteActions';
import {
    Applicants,
    ApplicantsIncome,
    ApplicationType,
    MortgageType,
    RequestedLoan,
} from './components';

function QuickQuoteContainer(props) {
    return (
        <div>
            <ApplicationType
                applicationType={props.applicationType}
                setApplicationType={props.setApplicationType}
            />
            <Applicants
                applicationType={props.applicationType}
                applicants={props.applicants}
                setApplicants={props.setApplicants}
            />
            <MortgageType
                applicationType={props.applicationType}
                applicants={props.applicants}
                mortgageType={props.mortgageType}
                setStepsUncompleted={props.setStepsUncompleted}
                setStepCompleted={props.setStepCompleted}
                setMortgageType={props.setMortgageType}
            />
            <ApplicantsIncome
                applicants={props.applicants}
                mortgageType={props.mortgageType}
                applicantsIncome={props.applicantsIncome}
                setApplicantsIncome={props.setApplicantsIncome}
            />
            <RequestedLoan
                applicationId={props.applicationId}
                applicationType={props.applicationType}
                mortgageType={props.mortgageType}
                applicantsIncome={props.applicantsIncome}
                estaminatedPropertyValue={props.estaminatedPropertyValue}
                estaminatedPropertyMonthlyRent={props.estaminatedPropertyMonthlyRent}
                requestedLoanAmount={props.requestedLoanAmount}
                requestedTimeSpan={props.requestedTimeSpan}
                customer={props.customer}
                steps={props.steps}
                setStep={props.setStep}
                setStepCompleted={props.setStepCompleted}
                setStepsUncompleted={props.setStepsUncompleted}
                setEstaminatedPropertyValue={props.setEstaminatedPropertyValue}
                setEstaminatedPropertyMonthlyRent={props.setEstaminatedPropertyMonthlyRent}
                setRequestedLoanAmount={props.setRequestedLoanAmount}
                setRequestedTimeSpan={props.setRequestedTimeSpan}
                setApplicantsIncome={props.setApplicantsIncome}
                getQuickQuote={props.getQuickQuote}
                setApplicationId={props.setApplicationId}
            />
        </div>
    );
}

const mapStateToProps = state => ({
    applicationId: state.applicationIdReducer,
    applicationType: state.quickQuoteReducer.applicationType,
    applicants: state.quickQuoteReducer.applicants,
    mortgageType: state.quickQuoteReducer.mortgageType,
    applicantsIncome: state.quickQuoteReducer.applicantsIncome,
    estaminatedPropertyValue: state.quickQuoteReducer.property.estaminatedPropertyValue,
    estaminatedPropertyMonthlyRent: state.quickQuoteReducer.property.estaminatedPropertyMonthlyRent,
    requestedLoanAmount: state.quickQuoteReducer.requestedLoanAmount,
    requestedTimeSpan: state.quickQuoteReducer.requestedTimeSpan,
    customer: state.customerReducer,
});

const mapDispatchToProps = dispatch => ({
    setApplicationType: (applicationType) => {
        dispatch(setApplicationType(applicationType));
    },
    setApplicants: (applicationType) => {
        dispatch(setApplicants(applicationType));
    },
    setMortgageType: (mortgageType) => {
        dispatch(setMortgageType(mortgageType));
    },
    setApplicantsIncome: (index, event) => {
        dispatch(setApplicantsIncome(index, event));
    },
    setEstaminatedPropertyValue: (event) => {
        dispatch(setEstaminatedPropertyValue(event));
    },
    setEstaminatedPropertyMonthlyRent: (event) => {
        dispatch(setEstaminatedPropertyMonthlyRent(event));
    },
    setRequestedLoanAmount: (event) => {
        dispatch(setRequestedLoanAmount(event));
    },
    setRequestedTimeSpan: (event) => {
        dispatch(setRequestedTimeSpan(event));
    },
    getQuickQuote: params => dispatch(getQuickQuote(params)),
});

QuickQuoteContainer.propTypes = {
    applicationId: PropTypes.string.isRequired,
    applicationType: PropTypes.string.isRequired,
    applicants: PropTypes.number.isRequired,
    mortgageType: PropTypes.string.isRequired,
    applicantsIncome: PropTypes.array.isRequired,
    estaminatedPropertyValue: PropTypes.object.isRequired,
    estaminatedPropertyMonthlyRent: PropTypes.object.isRequired,
    requestedLoanAmount: PropTypes.object.isRequired,
    requestedTimeSpan: PropTypes.number.isRequired,
    customer: PropTypes.object.isRequired,
    steps: PropTypes.array.isRequired,
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setStepsUncompleted: PropTypes.func.isRequired,
    setApplicationType: PropTypes.func.isRequired,
    setApplicants: PropTypes.func.isRequired,
    setMortgageType: PropTypes.func.isRequired,
    setApplicantsIncome: PropTypes.func.isRequired,
    setEstaminatedPropertyValue: PropTypes.func.isRequired,
    setEstaminatedPropertyMonthlyRent: PropTypes.func.isRequired,
    setRequestedLoanAmount: PropTypes.func.isRequired,
    setRequestedTimeSpan: PropTypes.func.isRequired,
    getQuickQuote: PropTypes.func.isRequired,
    setApplicationId: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(QuickQuoteContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/QuickQuote/QuickQuoteContainer.js